import { render, staticRenderFns } from "./ClipboardTextClock.vue?vue&type=template&id=6a679cf7"
import script from "./ClipboardTextClock.vue?vue&type=script&lang=js"
export * from "./ClipboardTextClock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports